var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tag-view" },
    [
      _c("image-toolbox", {
        attrs: {
          selectedNum: _vm.selectedNum,
          selectedType: _vm.selectedType,
          selectedImages: _vm.selectedImages,
          loadedAllImageNum: _vm.tags.length
        },
        on: {
          closeSelected: _vm.closeSelected,
          selectedAll: _vm.selectedAll,
          cancelSelectedAll: _vm.cancelSelectedAll
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view-content tag-view-content clearfix" },
        [
          _c(
            "div",
            {
              staticClass: "fixed-line clearfix",
              class: { show: _vm.tags.length > 0 }
            },
            [
              _c("div", { staticClass: "total-item" }, [
                _vm._v(
                  _vm._s(_vm.$t("list.total")) +
                    " " +
                    _vm._s(_vm.total) +
                    " " +
                    _vm._s(_vm.$t("list.items"))
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.tags, function(tag, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "view-item tag-item",
                class: { selected: tag.selected },
                on: {
                  click: function($event) {
                    return _vm.goTagDetail(index)
                  }
                }
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c("div", { staticClass: "layer layer-under" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-middle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-upper" }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "bookmark",
                    attrs: {
                      src: require("../../assets/images/bookmark.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "img-wrap",
                      class: { "img-wrap-empty": tag.count === 0 }
                    },
                    [
                      _c("img", {
                        staticClass: "defaul-tag-img",
                        attrs: { src: tag.smallUrl, alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "empty-text" }, [
                        _vm._v(_vm._s(_vm.$t("list.empty")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-item-t tag-msg" }, [
                    _c("span", { staticClass: "tag-title" }, [
                      _vm._v(_vm._s(tag.name) + "（" + _vm._s(tag.count) + "）")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "checkbox",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.selectedFn(index)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tag-mark" })
              ]
            )
          }),
          _vm._v(" "),
          _vm.showNoFile
            ? _c("div", { staticClass: "no-file" }, [
                _c("div", { staticClass: "no-file-main" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/images/no_file.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.$t("list.noFile")))])
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("processing", { attrs: { processing: _vm.processing } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-496d8d6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496d8d6d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/Tags.vue
// module id = null
// module chunks = 